"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ico_close_png_1 = __importDefault(require("../../../../assets/img/ico-close.png"));
const bg_wid_gradient_png_1 = __importDefault(require("../../../../assets/img/bg_wid_gradient.png"));
const ico_error_png_1 = __importDefault(require("../../../../assets/img/ico-error.png"));
const styles_1 = require("@mui/styles");
const familyFontConst = '"Open Sans", Helvetica,Arial,sans-serif';
exports.default = (0, styles_1.makeStyles)(() => ({
    dialog: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        borderRadius: '5px',
        borderWidth: '0px',
        color: '#2f3c54',
        marginTop: '-160px',
        fontFamily: familyFontConst,
        background: `url(${bg_wid_gradient_png_1.default}) repeat-x left bottom #fff`,
        overflow: 'hidden',
        width: '315px'
    },
    DialogContent: {
        borderWidth: 0,
        width: '313px',
        height: '112px',
        overflow: 'hidden',
        position: 'relative',
        marginTop: '-11px'
    },
    WrapIcon: {
        position: 'relative',
        background: `url(${ico_error_png_1.default}) no-repeat`,
        width: 24,
        height: 24,
        display: 'block',
        backgroundSize: 'contain'
        // marginTop: '9px',
        // marginLeft: '-12px'
    },
    ListItem: {
        width: 'auto',
        marginTop: '15px'
    },
    typography: {
        marginLeft: '-5px',
        wordBreak: 'break-all',
        marginTop: '-1px',
        color: '#2f3c54',
        fontWeight: 600,
        fontFamily: familyFontConst,
        fontSize: '12px'
    },
    Error2FATitle: {
        color: '#2f3c54',
        fontWeight: 'bold',
        // margin: '25px 100px',
        // padding: '24px 0 10px',
        margin: '30px 0 0',
        fontSize: '103%',
        // marginTop: '15px',
        // marginLeft: '19px',
        fontFamily: familyFontConst,
        fontStyle: 'normal'
    },
    IconClose: {
        position: 'relative',
        background: `url(${ico_close_png_1.default}) no-repeat`,
        backgroundSize: 'contain',
        width: 16,
        height: 16,
        display: 'block',
        marginLeft: '128px',
        marginTop: '-16px',
        cursor: 'pointer',
        zIndex: 1103
    },
    ConfirmButton: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
        paddingTop: '10px',
        margin: '10px 10px 0'
    },
    OK: {
        boxSizing: 'border-box',
        background: 'linear-gradient(180deg, #606060 0, #505050 100%)',
        border: '1px solid #595959',
        borderRadius: '5px',
        fontWeight: 'bold',
        textAlign: 'center',
        padding: '9px 12px',
        color: '#FFF',
        display: 'block',
        float: 'left',
        fontSize: '13px',
        height: 'auto',
        lineHeight: 'normal',
        minWidth: '115px',
        outline: 0,
        position: 'relative',
        margin: '15px 0',
        textTransform: 'none',
        textShadow: 'none',
        fontFamily: familyFontConst,
        '&:hover': {
            background: 'linear-gradient(180deg, #606060 0, #505050 100%)'
        },
        '&:focus': {
            border: '1px solid #595959 !important',
            boxShadow: 'inset #e6e6e6 0 0 4px 0'
        }
    }
}));
